import { AbstractControl } from "@angular/forms";

export function ValidateDate(control: AbstractControl) {
  const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
  if (!control.value.match(regex)) {
    return {validDate: false};
  }
  return null;
}
